import { useState } from 'react';
import { Base64 } from 'js-base64';
import axios from 'axios';

import { getBaseRequestConfig } from '../../utils/requestConfig';
import FormLogin from './FormLogin';


const emailRegExp = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
const isEmailFormatValid = (email: string) => email.match(emailRegExp);

const areRequiredFieldsNotEmpty = (email: string, password: string) => !email || !password;
const isValidationErrored = (err: string) => Boolean(err);

type FormLoginContainerProps = {
  onFailure: (error: unknown) => void,
  onUserLoggedIn: () => void,
  onLoadingChange?: (isLoading: boolean) => void
}

export default function FormLoginContainer({ onFailure, onUserLoggedIn, onLoadingChange }: FormLoginContainerProps) {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailValidationError, setEmailValidationError] = useState('');

  const validateEmailField = (event: React.FocusEvent<HTMLInputElement>) => {
    if (!isEmailFormatValid(event.target.value)) {
      setEmailValidationError('Invalid email format: example@domain.com');
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    if (emailValidationError && name === 'email' && isEmailFormatValid(value)) {
      setEmailValidationError('');
    }
    if (name === 'email') {
      setEmail(value);
    }
    if (name === 'password') {
      setPassword(value);
    }
  };

  const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const requestUrl = `/api/auth/form/login`;
    const authPayload = Base64.encode(`${email}:${password}`);

    onLoadingChange?.(true);
    axios
      .post(requestUrl,
        { credentials: authPayload },
        getBaseRequestConfig())
      .then(() => {
        onUserLoggedIn();
      })
      .catch(error => {
        onLoadingChange?.(false);
        onFailure(error);
      });
  };

  const isSubmitDisabled = areRequiredFieldsNotEmpty(email, password) || isValidationErrored(emailValidationError);

  return (
    <FormLogin handleFormSubmit={handleFormSubmit}
               handleInputChange={handleInputChange}
               handleOnBlur={validateEmailField}
               emailValidationError={emailValidationError}
               isSubmitDisabled={isSubmitDisabled}
    />
  );

}
